import { IAddress } from "../Addresses"
import { ILocation } from "../Locations"
import { ITag } from "../Tags"
import { ILatestGivenQuote, ITrip } from "../Trips"
import { ITripSource } from "../TripSources"
import { TWorldAirport } from "../World"
import { IPhoneNumber, IEmail } from "./../Contacts"
import { TTripDestination } from "./../TripDestinations"
import { TFormattedMoney } from "@sembark-travel/money"

export type TTouristProfile = {
	id: number
	name: string
	name_without_salutation: string
	is_primary: 0 | 1 | "0" | "1"
	phone_number: string
	email?: string
	number?: number
	country_code?: string
	phone_numbers: Array<IPhoneNumber<TTouristProfile>>
	emails?: Array<IEmail<TTouristProfile>>
	destinations?: Array<TTripDestination>
	latest_given_quote?: ILatestGivenQuote
	latest_stage_name?: string
	trip_source?: ITripSource
	address?: IAddress
	trips?: Array<ITrip>
	trips_count?: number
	documents: {
		name: string
		uid: string
		document_id?: number
		document_type_id: number
		media_url?: string
		is_uploaded?: boolean
		file?: File
	}[]
	dob?: string
	nationality?: ILocation["country"]
	type: "adult" | "child"
	salutation?: "Mr." | "Mrs." | "Ms."
	gender?: "male" | "female" | "others"
	total_queries: number | null
	total_converted_queries: number | null
	total_revenue: Array<TFormattedMoney>
	meal_preference: string
	stay_preference: string
	language_preference?: string
	preferred_airport?: TWorldAirport
	preferred_flight_class?: string
	marriage_anniversary?: string
	is_smoker?: 1 | 0 | null
	tags?: Array<ITag>
	passport_number?: string
	passport_expiry_date?: string
	company_name?: string
	gst_number?: string
	remarks?: string
	created_at: string
	deleted_at?: string
}

export type TPreference = {
	id: string
	name: string
}

export type TFlightClass =
	| "Business"
	| "Economy"
	| "First Class"
	| "Premium Economy"

export const FLIGHT_CATEGORY_CLASSES: Array<TFlightClass> = [
	"Economy",
	"Premium Economy",
	"Business",
	"First Class",
]

export type TSmoking = "Yes" | "No"

export const SMOKING_PREFERENCES: Array<TSmoking> = ["Yes", "No"]
